import {mixin} from "@/helpers/helper";
import {Errors} from "@/helpers/Errors";

export default {
    namespaced: true,
    state: {
        errors: {},
        bread_active: null,
        bread_list: null,
        regionList: null,
        zoneList: null,
        zoneFolderList:null,
        zoneListOfCity: null,
        compravendita: null,
        zoneInfo: null,
        cityId: null,
        city: null,
        idToDelete: null,
        setIdToNotClone:null,
        idZoneToDelete: null,
        componentKey: 0,
        buildingList: [],
        buildingDetail: null,
        streetPrice: null,
        formData: null,
        myError: null,
        customRange: null,
        showMappingListCard: false,
        customAc: {},
        ac: {0: 'active'},

        citiesAutoComplete: [],
        zoneSavedData: null,
        zoneSaved: false,
        rotateSpin: '',
        rotateColorSpin: '',
        showBinIcon: false,
        mappedBuilding: null,
        showCard: false,
        showLoadingIcon: false,
        counterMap_: 0,
        alreadyImported: [],
        toDelete: [],
        checkedBuildings: null,
        searchType: null,
        showAllZonesInOne: false,
        activeAllZone: null,


        startLastMapping: false,

        buildingTypes: 1,
        renovated: 0,
        activateLoading: false,
        tempCircle: {},
        makeCircle: false,
        polygonsContainer: [],
        circlesContainer: [],
        allZonesPolygonLoading: false,
        showAllZonesButton: false,
        streetPricePercentage: 70,
        buildingType: 1,
        showSearchAlertModal: false,
        userCountry: null,
        loadingBarData: {percentage: 0},
        isZoneUpdateAlert: false,
        monthlyCounter: 0,
        monthlyZoneCounter: 0,
        folderName:null,
        checkedZones:[],
        allFolder:null,
        folderId:null,
        isWalletFull: null,
        checkBoxWallet: 0,

        },
    getters: {
        priceMq: state => {
            let total = 0;
            let count = 0;
            state.buildingList.forEach(function (record) {
                if (record.active === 1) {
                    count++;
                    let pmq = (record.prezzo / record.mq);
                    total = (total * 10 + pmq * 10) / 10;
                }

            });
            total = (total / count);
            return total;
        },
    },
    mutations: {
        SET_DATA: function (state, data) {
            eval("state." + data.name + " = data.data;");
        }
    },
    actions: {
        clearForm(state) {

            state.state.formData = {
                via: ' ',
                mq: ' ',
                prezzo: 0,
                locali: ' ',
                piano: ' ',
                ascensori: ' ',
                bagni: ' ',
                ristrutturazione: ' ',
                link: ' ',
                note: ' ',
                id: 0,
                broken_link: 0,
                dataMap: [],
            }

        },

        rangeMqCustom(state) {
            axios.get('/api/v2/mapping/rangeMq/' + state.state.zoneInfo.id)
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'customRange', data: response.data
                    });
                })
        },

        tabOn(state, payload) {
            Object.keys(state.state.ac).forEach(function (key) {
                state.state.ac[key] = '';
            });
            Object.keys(state.state.customAc).forEach(function (key) {
                state.state.customAc[key] = '';
            });
            payload.index != null ? state.state.customAc[payload.index] = 'active' : state.state.ac[payload.mqRange] = 'active';
        },

        regionByUser(state) {
            axios.get('/api/v2/mapping/mappingListByRegion/')
                .then(response => {

                    state.commit('SET_DATA', {
                        name: 'userCountry', data: response.data.userCountry
                    });
                    state.commit('SET_DATA', {
                        name: 'regionList', data: response.data.regionList
                    });
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        window.location.href = '/login?msg=session_expired';
                    }

                })

        },

        lastMapping(state, payload) {
            state.commit('SET_DATA', {
                name: 'zoneListOfCity', data: null
            });
            axios.get('/api/v2/mapping/lastMapping')
                .then(response => {
                    state.dispatch('zoneByCity', {
                        cityId: response.data.cityId,
                        city: response.data.city
                    });

                    if (!payload || !payload.route || !payload.route.hash) {

                        state.dispatch('buildingByZone', {z: response.data.zoneInfo});
                    }
                    state.commit('SET_DATA', {
                        name: 'startLastMapping', data: true
                    });

                    state.commit('SET_DATA', {
                        name: 'cityId', data: response.data.cityId
                    });
                    state.dispatch('clearForm');
                })

        },

        zoneByCity(state, payload) {
            state.commit('SET_DATA', {
                name: 'cityId', data: payload.cityId
            });
            state.commit('SET_DATA', {
                name: 'city', data: payload.city
            });
            state.commit('SET_DATA', {
                name: 'folderId', data: payload.folderId
            });
            state.commit('SET_DATA', {
                name: 'zoneInfo', data: null
            });
            state.commit('SET_DATA', {
                name: 'showMappingListCard', data: false
            });

            state.commit('SET_DATA', {
                name: 'showAllZonesInOne', data: false
            });
            axios.get('/api/v2/mapping/retrieveZone/' + payload.cityId + '/' + payload.folderId)
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'activeAllZone', data: null
                    });
                    state.commit('SET_DATA', {
                        name: 'zoneList', data: response.data.data
                    });
                    state.commit('SET_DATA', {
                        name: 'zoneFolderList', data: response.data.folderzones
                    });

                    response.data.zoneListOfCity.forEach((myZone) =>{
                       if(myZone.compravendita.length > 0)
                       {
                           state.commit('SET_DATA', {
                               name: 'compravendita', data: myZone
                           });
                       }
                    })

                    state.commit('SET_DATA', {
                        name: 'zoneListOfCity', data: null
                    });
                })

        },

        allZoneByCity(state, payload) {
            state.commit('SET_DATA', {
                name: 'cityId', data: payload.cityId
            });
            state.commit('SET_DATA', {
                name: 'city', data: payload.city
            });
            state.commit('SET_DATA', {
                name: 'showAllZonesInOne', data: true
            });
            axios.get('/api/v2/mapping/retrieveZone/' + payload.cityId + '/' + payload.folderId)
                .then(response => {

                    state.commit('SET_DATA', {
                        name: 'zoneList', data: response.data.data
                    });
                    state.commit('SET_DATA', {
                        name: 'zoneListOfCity', data: response.data.zoneListOfCity
                    });
                    state.commit('SET_DATA', {
                        name: 'showMappingListCard', data: true
                    });
                    state.commit('SET_DATA', {
                        name: 'activeAllZone', data: 'allzone-active'
                    });
                    state.dispatch('forceRender');
                })
        },

        changeStatus(state, payload) {
            axios.post('/api/v2/mapping/changeStatus', {
                buildingId: payload.building.id,
                status: payload.status
            })
                .then(() => {
                    if (!payload.reload) {
                        state.dispatch('buildingByZone', {z: state.state.zoneInfo})
                    }
                })
        },

        buildingByZone(state, payload) {
            state.commit('SET_DATA', {
                name: 'showAllZonesInOne', data: false
            });

            if (payload != null) {
                state.commit('SET_DATA', {
                    name: 'zoneInfo', data: payload.z
                });
             }

            if (payload != null && payload.streetPrice) {
                state.commit('SET_DATA', {
                    name: 'streetPricePercentage', data: payload.streetPrice
                });
            }

            axios.get('/api/v2/mapping/mappingList/' + state.state.zoneInfo.id + '/' + payload.z.range + '/' + state.state.streetPricePercentage +
                '/' + state.state.buildingType +
                '/?renovated=' + state.state.renovated
            )
                .then(function (response) {

                    state.commit('SET_DATA', {
                        name: 'activeAllZone', data: null
                    });
                    state.commit('SET_DATA', {
                        name: 'buildingList',
                        data: response.data.data.sort((a, b) => {
                                let comparison = 0;
                                if (a.active < b.active) {
                                    comparison = 1;
                                } else if (a.active > b.active) {
                                    comparison = -1;
                                }
                                return comparison;
                            }
                        )
                    });
                    state.commit('SET_DATA', {
                        name: 'streetPrice', data: response.data.streetPrice
                    });
                    state.commit('SET_DATA', {
                        name: 'priceMq', data: 0
                    });
                    state.dispatch('rangeMqCustom');
                    state.commit('SET_DATA', {
                        name: 'showMappingListCard', data: true
                    });
                    setTimeout(() => {
                        state.commit('SET_DATA', {
                            name: 'activateLoading', data: false
                        });
                    }, 1500)
                    state.commit('SET_DATA', {
                        name: 'zoneListOfCity', data: null
                    });

                    if (payload.z.range == null) {
                        state.dispatch('forceRender');
                    }
                })
        },


        comparabili(state, payload) {
            state.commit('SET_DATA', {
                name: 'showAllZonesInOne', data: false
            });

            if (payload != null) {
                state.commit('SET_DATA', {
                    name: 'zoneInfo', data: payload.z
                });
            }

            if (payload != null && payload.streetPrice) {
                state.commit('SET_DATA', {
                    name: 'streetPricePercentage', data: payload.streetPrice
                });
            }

            axios.get('/api/v2/mapping/comparabili/' + state.state.zoneInfo.id + '/' + payload.z.range + '/' + state.state.streetPricePercentage +
                '/' + state.state.buildingType +
                '/?renovated=' + state.state.renovated
            )
                .then(function (response) {

                    state.commit('SET_DATA', {
                        name: 'activeAllZone', data: null
                    });
                    state.commit('SET_DATA', {
                        name: 'buildingList',
                        data: response.data.data.sort((a, b) => {
                                let comparison = 0;
                                if (a.active < b.active) {
                                    comparison = 1;
                                } else if (a.active > b.active) {
                                    comparison = -1;
                                }
                                return comparison;
                            }
                        )
                    });
                    state.commit('SET_DATA', {
                        name: 'streetPrice', data: response.data.streetPrice
                    });
                    state.commit('SET_DATA', {
                        name: 'priceMq', data: 0
                    });
                    state.dispatch('rangeMqCustom');
                    state.commit('SET_DATA', {
                        name: 'showMappingListCard', data: true
                    });
                    setTimeout(() => {
                        state.commit('SET_DATA', {
                            name: 'activateLoading', data: false
                        });
                    }, 1500)
                    state.commit('SET_DATA', {
                        name: 'zoneListOfCity', data: null
                    });

                    if (payload.z.range == null) {
                        state.dispatch('forceRender');
                    }
                })
        },


        forceRender(state) {
            state.commit('SET_DATA', {
                name: 'componentKey', data: state.state.componentKey += 1
            });
        },

        saveCustomRangeData(state, payload) {
            payload.id = state.state.zoneInfo.id;
            axios.post('/api/v2/mapping/saveCustomRangeData', payload)
                .then(() => {
                    state.dispatch('buildingByZone', {z: state.state.zoneInfo})
                })
        },

        deleteCustomRange(state, payload) {
            axios.get('/api/v2/mapping/deleteCustomRange/' + payload)
                .then(() => {
                    state.dispatch('tabOn', null);
                    state.dispatch('buildingByZone', {z: state.state.zoneInfo})
                })
        },

        sendMappingData(state, payload) {
            axios.post('/api/v2/mapping/sendMappingData', {
                via: state.state.formData.via,
                mq: mixin.methods.REMOVE_DOT(state.state.formData.mq),
                prezzo: mixin.methods.REMOVE_DOT(state.state.formData.prezzo),
                locali: mixin.methods.REMOVE_DOT(state.state.formData.locali),
                piano: mixin.methods.REMOVE_DOT(state.state.formData.piano),
                ascensori: state.state.formData.ascensori,
                bagni: mixin.methods.REMOVE_DOT(state.state.formData.bagni),
                ristrutturazione: state.state.formData.ristrutturazione,
                data: state.state.formData.data,
                link: state.state.formData.link,
                note: state.state.formData.note,
                zone_id: (state.state.zoneInfo) ? state.state.zoneInfo.id : null,
                city_id: state.state.cityId,
                id: state.state.formData.id,
                type: state.state.formData.type,
                renovated: state.state.formData.renovated
            })
                .then(() => {
                    // state.dispatch('tabOn', {'mqRange': 0, 'index': null});
                    // state.state.zoneInfo.range = 0;
                    // state.dispatch('buildingByZone', {z: state.state.zoneInfo})
                    state.commit('SET_DATA', {
                        name: 'errors', data: {}
                    });

                    if (payload && payload.modal) {
                        payload.modal.hide('m-building');
                    }

                    if (payload && payload.reload) {
                        state.dispatch('reloadBuildings');
                    }
                })
                .catch(({response}) => {
                    state.commit('SET_DATA', {
                        name: 'errors', data: {}
                    });
                    let errors = new Errors();
                    errors.record(response.data.errors);
                    state.commit('SET_DATA', {
                        name: 'errors', data: errors.errors
                    });
                })

        },

        exportExcel(state) {
            axios.get('/api/v2/mapping/exportExcel/' + state.state.zoneInfo.id + '/' + state.state.streetPricePercentage + '/' + state.state.buildingType)
                .then(response => {
                    let percentage = 100 - state.state.streetPricePercentage;
                    window.location.href = '/storage/' + response.data + '/' + state.state.zoneInfo.id + '_mapping' + '_' + percentage + '.xlsx';
                })

        },

        saveStreetPriceIntoBuildingData(state, payload) {
            axios.post('/api/v2/mapping/saveStreetPriceIntoBuildingData', {
                idBuilding: payload.idBuilding,
                streetPrice: payload.streetPrice
            })
        },

        createOperation(state, payload) {

            axios.get('/api/v2/mapping/createOperation/' + payload.idBuilding)
                .then(response => {
                    state.dispatch('saveStreetPriceIntoBuildingData', payload);
                    window.location.href = "/custom/" + response.data.idBuilding + '/' + response.data.idOperation;
                })
        },

        deleteBuilding(state, payload) {
            axios.get('/api/v2/mapping/deleteSingleBuilding/' + state.state.idToDelete)
                .then(() => {
                    if (payload && payload.isMyOperation) {
                        this.dispatch('n_dashboard/buildingsByStatus');
                    } else {
                        state.dispatch('buildingByZone', {z: state.state.zoneInfo})
                    }
                    state.dispatch('clearForm');
                })
        },

       notClone(state) {
            axios.get('/api/v2/mapping/notClone/' + state.state.idNotClone)
                .then(() => {

                        state.dispatch('buildingByZone', {z: state.state.zoneInfo})

                })
        },
        deleteZone(state, payload) {
            axios.get('/api/v2/mapping/deleteZone/' + state.state.idZoneToDelete)
                .then(() => {
                    state.dispatch('regionByUser'); // reset number zone after delete
                    state.dispatch('zoneByCity', payload)
                    window.location.reload();
                })
        },

        editZoneData(state) {
            axios.post('/api/v2/mapping/editZoneData/', state.state.zoneInfo)
                .then(() => {
                })
        },

        activateDeactivate(state, payload) {
            state.commit('SET_DATA', {
                name: 'activateLoading', data: true
            });
            axios.get('/api/v2/mapping/activateDeactivate/' + payload.id)
                .then(() => {
                    state.dispatch('buildingByZone', {z: state.state.zoneInfo})
                })
        },

        cityListByName(state, payload) {
            axios.post('/api/v2/mapping/cityBySlug', {input: payload.input})
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'citiesAutoComplete', data: response.data
                    });
                    state.commit('SET_DATA', {
                        name: 'stopSearch', data: true
                    });
                })
        },
        sendZoneData(state, payload) {

            // state.commit('SET_DATA', {name: 'zoneSaved', data: false}); //  to refresh route that show map

            state.commit('SET_DATA', {
                name: 'searchType', data: payload.searchType
            }); //  for auction street price

            axios.post('/api/v2/mapping/sendZoneData', payload)
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'zoneSavedData',
                        data: {
                            region: payload.region, zoneId: response.data
                        }
                    });
                    // state.commit('SET_DATA', {name: 'zoneSaved', data: true});
                    if (state.state.searchType === 'scan') {
                        state.dispatch('searchText', {address: payload.address});
                    }
                })
                .catch(error => {
                    if (error.response) {
                        state.commit('SET_DATA', {
                            name: 'myError', data: error.response.data.errors
                        });
                    }
                });
        },

        checkAds(state) {
            state.commit('SET_DATA', {
                name: 'rotateSpin', data: ' fa-spin'
            });
            state.commit('SET_DATA', {
                name: 'showBinIcon', data: false
            });
            state.commit('SET_DATA', {
                name: 'rotateColorSpin', data: ' background-color:orange !important'
            });

            const timeout = setTimeout(() => {
                window.location.reload();
                // Timeout Logic
            }, 130000);

            axios.get('/api/v2/buildingImport/checkAds/' + state.state.zoneInfo.id)
                .then(() => {
                    clearTimeout(timeout);
                    state.dispatch('buildingByZone', {z: state.state.zoneInfo})
                    // state.commit('SET_DATA', {
                    //     name: 'rotateSpin', data: ''
                    // });
                    state.commit('SET_DATA', {
                        name: 'showBinIcon', data: true
                    });
                    state.commit('SET_DATA', {
                        name: 'rotateColorSpin', data: ''
                    });
                })
        },

        removeCheckBrokenLink(state, payload) {
            axios.get('/api/v2/buildingImport/removeCheckBrokenLink/' + payload)
                .then(() =>{
                    state.dispatch('buildingByZone', {z: state.state.zoneInfo})
                    // state.commit('SET_DATA', {
                    //     name: 'rotateSpin', data: ''
                    // });
                    state.commit('SET_DATA', {
                        name: 'showBinIcon', data: false
                    });
                    state.commit('SET_DATA', {
                        name: 'rotateColorSpin', data: ''
                    });
                })
        },

        deleteAdsOutdated(state) {
            axios.get('/api/v2/buildingImport/deleteAdsOutdated/' + state.state.zoneInfo.id)
                .then(response => {
                    state.dispatch('buildingByZone', {z: state.state.zoneInfo})
                    // state.commit('SET_DATA', {
                    //     name: 'rotateSpin', data: ''
                    // });
                    state.commit('SET_DATA', {
                        name: 'showBinIcon', data: false
                    });
                    state.commit('SET_DATA', {
                        name: 'rotateColorSpin', data: ''
                    });
                })
        },

        zoneData(state, payload) {
            axios.get('/api/v2/mapping/' + payload.zoneId)
                .then(function (response) {
                    state.commit('SET_DATA', {
                        name: 'zoneInfo', data: response.data.zoneData
                    });
                    state.commit('SET_DATA', {
                        name: 'showAllZonesButton', data: response.data.showAllZonesButton
                    });
                    state.commit('SET_DATA', {
                        name: 'mappedBuilding', data: response.data.mappedBuilding
                    });
                    state.commit('SET_DATA', {
                        name: 'monthlyCounter', data: response.data.monthlyCounter
                    });
                    state.commit('SET_DATA', {
                        name: 'monthlyZoneCounter', data: response.data.monthlyZoneCounter
                    });
                })
        },

        counterMap(state) {
            axios.get('/api/v2/buildingImport/counterMap')
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'counterMap_', data: response.data
                    });
                })
        },

        packDetailFree(state) {
            axios.get('/api/v2/buildingImport/packDetailFree')
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'packDetailFree_', data: response.data
                    });
                })
        },

        prepareDataToSend(state, payload) {
            state.commit('SET_DATA', {
                name: 'dataMap', data: payload
            });
        },

        searchText(state, payload) {
            state.commit('SET_DATA', {
                name: 'showCard', data: true
            });
            state.commit('SET_DATA', {
                name: 'showLoadingIcon', data: true
            });

            axios.post('/api/v2/buildingImport/searchText', {address: payload.address})
                .then(function (response) {
                    state.dispatch('substractForCounter');
                    state.commit('SET_DATA', {
                        name: 'buildingList', data: response.data.result
                    });
                    state.commit('SET_DATA', {
                        name: 'showSearchAlertModal', data: response.data.showSearchAlertModal
                    });
                    state.commit('SET_DATA', {
                        name: 'alreadyImported', data: response.data.alreadyImported
                    });
                    state.commit('SET_DATA', {
                        name: 'showLoadingIcon', data: false
                    });
                })

        },

        searchGoogleMap(state) {
            state.commit('SET_DATA', {
                name: 'showCard', data: true
            });
            state.commit('SET_DATA', {
                name: 'showLoadingIcon', data: true
            });
            state.state.loadingBarData.interval = setInterval(() => {
                if (state.state.loadingBarData.percentage === 100) {
                    clearInterval(state.state.loadingBarData.interval);
                    return;
                }

                state.state.loadingBarData.percentage++;
            }, state.state.userCountry === 2 ? 1500 : 1500);

            axios.post('/api/v2/buildingimport/searchDraw', {
                dataSet: state.state.dataMap,
                zone_id: state.state.zoneInfo.id,
                mappedBuildings: state.state.mappedBuilding,
                packDetailFree: state.state.packDetailFree_,
                buildingTypes: state.state.buildingTypes,
                checkBoxWallet: state.state.checkBoxWallet,
            })
                .then(response => {
                    state.state.loadingBarData.state = "success";
                    state.state.loadingBarData.percentage = 100;
                    setTimeout(() => {
                        state.state.loadingBarData.percentage = 0;
                        state.state.loadingBarData.state = null;
                        clearInterval(state.state.loadingBarData.interval);
                    }, 1300)
                    state.dispatch('substractForCounter');
                    state.commit('SET_DATA', {
                        name: 'buildingList', data: response.data.result
                    });
                    state.commit('SET_DATA', {
                        name: 'showSearchAlertModal', data: response.data.showSearchAlertModal
                    });
                    state.commit('SET_DATA', {
                        name: 'isZoneUpdateAlert', data: response.data.isZoneUpdateAlert
                    });
                    state.commit('SET_DATA', {
                        name: 'alreadyImported', data: response.data.alreadyImported
                    });
                    state.commit('SET_DATA', {
                        name: 'toDelete', data: response.data.toDelete
                    });
                    state.commit('SET_DATA', {
                        name: 'showLoadingIcon', data: false
                    });
                    state.commit('SET_DATA', {
                        name: 'makeCircle', data: true
                    });
                    state.commit('SET_DATA', {
                        name: 'tempCircle.center', data: response.data.polygonCenter
                    });
                    state.commit('SET_DATA', {
                        name: 'tempCircle.radius', data: response.data.radius
                    });
                    state.commit('SET_DATA', {
                        name: 'monthlyCounter', data: response.data.monthlyCounter
                    });
                    state.commit('SET_DATA', {
                        name: 'monthlyZoneCounter', data: response.data.monthlyZoneCounter
                    });
                })
                .catch(error => {
                    state.state.loadingBarData.state = "error";
                    clearInterval(state.state.loadingBarData.interval);
                })
        },

        substractForCounter(state) {
            axios.get('/api/v2/buildingImport/substractForCounter')
                .then(() => {
                    state.dispatch('counterMap');
                })
        },

        importData(state, payload) {
            //state.commit('SET_DATA', {name: 'zoneSaved', data: false}); //  to refresh route that show map
            state.commit('SET_DATA', {name: 'zoneSaved', data: false}); // to force refreshing
            axios.post('/api/v2/buildingimport/importData', {
                buildingData: state.state.buildingList,
                checkedBuildings: payload,
                comune: state.state.zoneInfo.town,
                zone_id: state.state.zoneInfo.id,
                city_id: state.state.zoneInfo.city_id,
                zone: state.state.zoneInfo.zone,
                macrozone: state.state.zoneInfo.macrozone,
                microzone: state.state.zoneInfo.microzone,
                type: state.state.buildingTypes
            })
                .then(() => {
                    state.commit('SET_DATA', {name: 'zoneSaved', data: true});
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

       saveFolder(state,payload) {

            axios.post('/api/v2/mapping/saveFolder', {
                cityId: state.state.cityId,
                folderId:state.state.folderId,
                folderName: state.state.folderName,
                checkedZones: state.state.checkedZones
            }).then( response => {
                    state.dispatch('allFolderByCity')
                    state.dispatch('zoneByCity', {
                        cityId: state.state.cityId,
                        folderId:state.state.folderId,
                    });
                    window.location.href = '/mapping/?cityId=' + state.state.cityId + '&city=' + response.data.city + '&folderId=' + response.data.folderId;
            }

            )


        },

        changeFolder(state, payload) {
            axios.post('/api/v2/mapping/changeFolder', {
                cityId: state.state.cityId,
                folderId:state.state.folderId,
                checkedZones: state.state.checkedZones
            }).then( response => {
                state.dispatch('allFolderByCity')
                state.dispatch('zoneByCity', {
                    cityId: state.state.cityId,
                    folderId:state.state.folderId,
                });
                window.location.href = '/mapping/?cityId=' + state.state.cityId + '&city=' + response.data.city + '&folderId=' + response.data.folderId;
            })

        },
        deleteFolder(state) {

            axios.get('/api/v2/mapping/deleteFolder/?cityId='+state.state.cityId + '&folderId=' + state.state.folderId, ).
            then( response => {
                    state.dispatch('allFolderByCity')
                state.dispatch('zoneByCity', {
                    cityId: state.state.cityId,
                });
                window.location.href = '/mapping/?cityId=' + state.state.cityId + '&city=' + response.data.city + '&folderId=0';
                }

            )


        },
        allFolderByCity(state){

            axios.get('/api/v2/mapping/allFolderByCity/?cityId=' + state.state.cityId)
                .then(
                    response => {


                state.commit('SET_DATA', {
                    name: 'allFolder', data: response.data.data
                });
            })
        },
        retrieveMappedBuilding(state, payload) {
            axios.get('/api/v2/mapping/retrieveMappedBuilding/' + payload.id)
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'buildingDetail', data: response.data
                    });
                })
        },

        getAllZonesPolygon(state, payload) {
            state.state.allZonesPolygonLoading = true;

            axios.get(`/api/v2/mapping/getAllZonesPolygon/${state.state.zoneInfo.user_id}/${state.state.zoneInfo.city_id}/${state.state.zoneInfo.id}`)
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'polygonsContainer', data: response.data.polygonsContainer
                    });
                    state.commit('SET_DATA', {
                        name: 'circlesContainer', data: response.data.circlesContainer
                    });
                })
        },

        reloadBuildings(state) {
            state.commit('SET_DATA', {
                name: 'activateLoading', data: true
            });
            state.dispatch('buildingByZone', {z: state.state.zoneInfo})
        },

        checkCreditWallet(state){
            axios.get(`/api/v2/wallet/checkCredit/` + 'idealista')
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'isWalletFull', data: response.data
                    });

                })
        }

    }
}
